import React from 'react';
import './styles.css'
import { Col, Container,Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
// NavDropdown,

function Footer() {
  

    return (
      <div className="footer">
      <hr />
      <Container>
          <Row>
              <Col className='logo' xs={12} md={3}>
                  <img
                  src="/assets/img/logo-menu.png"  // Reemplaza con la ruta de tu imagen
                  width="80"
                  height="75"
                  className="d-inline-block align-top"
                  alt="Logo"
                  />
              </Col>
              <Col xs={6} md={3}>
                  <h5>Empresa</h5>
                  <ul>
                      <li><Link to={'/'}>Sobre Nosotros</Link></li>
                      <li><Link to={'/'}>Trabaja con nosotros</Link></li>
                      <li><Link to={'/'}>Eventos</Link></li>
                      <li><Link to={'/'}>Contacto</Link></li>
                  </ul>
              </Col>
              <Col xs={6} md={3}>
                  <h5>Mercados</h5>
                  <ul>
                      <li>Guatemala</li>
                      <li>Panamá</li>
                      <li>El Salvador</li>
                      <li>Chile</li>
                      <li>Ecuador</li>
                      <li>Costa Rica</li>
                  </ul>
              </Col>
          </Row>
      </Container>
  </div>
    );
};

export default Footer;